export default __webpack_public_path__ + "static/media/payment-icon-1.39923df7.png";